<template>
  <div class="combo-market3">
    <ul class="combo-market3-tab">
      <template v-for="(tab, index) in tabList">
        <li
          v-show="tab.active"
          :key="tab.label"
          :class="{ active: curIndex === index }"
          @click="changeTab(index)"
        >
          {{ tab.label }}
        </li>
      </template>
    </ul>
    <template v-if="group.comboType === 3">
      <template v-for="(tab, index) in tabList">
        <Market2ThreeWay
          v-show="(curIndex === index && tab.active) || tab.visible"
          :key="`${tab.label}_${index}`"
          :market="comboMarketGroups.map[marketList[tab.label]]"
          :event="event"
          :visible="visible"
          @checkDeactive="checkDeactive"
        />
      </template>
    </template>
    <template v-else>
      <template v-for="(tab, index) in tabList">
        <Market1Specifier
          v-show="(curIndex === index && tab.active) || tab.visible"
          :key="`${tab.label}_${index}`"
          :markets="comboMarketGroups.map[marketList[tab.label]]"
          :event="event"
          :visible="visible"
          @checkDeactive="checkDeactive"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { ref, computed, onMounted, nextTick } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { useDetailStore } from '@ms/stores/matchDetail'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import Market1Specifier from './Market1Specifier.vue'
import Market2ThreeWay from './Market2ThreeWay.vue'

export default {
  name: 'MarketCombo3',
  components: {
    Market1Specifier,
    Market2ThreeWay
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { event } = storeToRefs(useMatchDetailStore())

    const { comboMarketGroups } = storeToRefs(useDetailStore())

    const curIndex = ref(0)
    const tabList = ref({})

    const marketList = computed(() => {
      const { marketGroups, comboType, comboGroupName } = props.group
      const groups = marketGroups.filter((x) => x.markets.length)

      const list = {}
      groups.forEach((x) => {
        const { marketTypeDesc, markets } = x
        const { id } = markets[0]
        list[marketTypeDesc] = `${comboType}_${comboGroupName}_${id}`
      })

      return list
    })

    const checkDeactive = (status, option) => {
      const label = option[0]
      const index = tabList.value.findIndex((x) => x.label === label)

      tabList.value[index].active = status

      if (!status) {
        for (let i = 0; i < tabList.value.length; i++) {
          if (tabList.value[i].active) {
            curIndex.value = i
            break
          }
        }
      }
    }

    const changeTab = (index) => {
      curIndex.value = index
    }

    onMounted(() => {
      const list = []
      props.group.marketGroups.forEach((group) => {
        if (group.markets.length) {
          list.push({ label: group.marketTypeDesc, active: true, visible: true })
        }
      })
      tabList.value = list

      // 此处暂时取巧，为了能获取初始为display: none的outcome宽度，计算conflict loading时间，从而避免多层props传递
      nextTick(() => {
        tabList.value.forEach((_x, index) => {
          tabList.value[index].visible = false
        })
      })
    })

    return {
      event,
      curIndex,
      tabList,
      marketList,
      comboMarketGroups,
      changeTab,
      checkDeactive
    }
  }
}
</script>

<style lang="scss">
.combo-market3 {
  &-tab {
    display: flex;
    height: 18px;
    padding-left: 20px;
    margin-bottom: 21px;
    color: #999;
    font-size: 14px;
    line-height: 18px;

    li {
      margin-right: 40px;

      &.active {
        position: relative;
        color: #ffca27;
        font-weight: 700;

        &::after {
          position: absolute;
          bottom: -9px;
          left: 50%;
          width: 30px;
          height: 2px;
          border-radius: 1.5px;
          background: #ffca27;
          content: "";
          transform: translateX(-15px);
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .combo-market3 {
  .combo-market3-tab li {
    color: #666;

    &.active {
      color: #333;

      &::after {
        width: 14px;
      }
    }
  }
}
</style>
